export default [
  {
    path: 'materials-requests/create/:view',
    name: 'new-material-request',
    meta: { permiso: '*', requiereLogin: true }, // TODO: set permission
    component: () => import('@/febos/global/materialsRequests/components/CreateMaterialsRequests')
  },
  {
    path: 'materials-requests/:view',
    name: 'material-requests',
    meta: { permiso: '*', requiereLogin: true }, // TODO: set permission
    component: () => import('@/febos/global/materialsRequests/vistas/MaterialsRequest')
  },
  {
    path: 'catalogs/:view',
    name: 'catalogs-maintenance',
    meta: { permiso: '*', requiereLogin: true }, // TODO: set permission
    component: () => import('@/febos/global/materialsRequests/components/CatalogsMaintenance')
  },
  {
    path: 'materials/:view',
    name: 'material-maintenance',
    meta: { permiso: '*', requiereLogin: true }, // TODO: set permission
    component: () => import('@/febos/global/materialsRequests/components/MaterialsMaintenance')
  },
  {
    path: 'materials/entity-management/:view',
    name: 'entity-management',
    meta: { permiso: '*', requiereLogin: true }, // TODO: set permission
    component: () => import('@/febos/global/materialsRequests/vistas/EntityManagement')
  }
];
